/*
 * 右边侧栏，答案部分 store
 * */

const state = {
  answerSheet: {
    acCardName: '',
    acCardNameFunctional: '',
    acCardPanes: 1, //布局：1、一栏，2、二栏，3三栏
    acCardYJType: 0, //评阅方式： 0、手批，1、网阅
    acCardDJType: 0, // 答卷类型: 0-自制, 1-组卷
    acCardStudentCodeType: 0, //考号填写模式：0-填涂考号， 1-条码 ，2-手写考号
    acCardExamNumber: 8, //考号位数
    acCardMissSign: false, //缺考标记：显示-true，隐藏-false
    acCardHideScore: false, //隐藏分值：显示-true，隐藏-false
    acCardHideOrCode: false, //隐藏二维码：显示-true，隐藏-false
    acCardPint: 2, //单面打印：1-单面  2-双面
    acCardABSet: false, //AB卷：开启-true，关闭-false
    abPaperModel: ['1'], //答案内AB卷设置
  },
  acCardSetType: 0, // 答卷设置（会影响预览展示考生信息页的高度）  0、正常 1、条码 2、手写考号 3、二栏且考号位数大于9 或 三栏且考号位数大于8
  hideScore: false, //隐藏分值：显示-true，隐藏-false
  visibleDialog: null,
  visibleDialogIndex: 0,
};

const mutations = {
  SET_ANSWER_SHEET(state, val) {
    state.answerSheet = {
      ...state.answerSheet,
      ...val,
    };
  },
  SET_CARD_SET_TYPE(state, val) {
    state.acCardSetType = val;
  },
  SET_VISIBLE_DIALOG(state, val) {
    state.visibleDialog = val;
    console.log(state.visibleDialog, ' state.visibleDialog');
  },
  SET_VISIBLE_DIALOG_INDEX(state, val) {
    state.visibleDialogIndex = val;
  },
  SET_SCORE_VISIBLE(state, val) {
    document.querySelectorAll('.topic-wrapper iframe').forEach(iframe => {
      if (iframe.contentWindow) {
        iframe.contentWindow.document.body.className = val ? 'hide-score view' : 'show-score view';
      }
    });
  },
};

const actions = {
  answerSheetAction({ commit }, val) {
    commit('SET_ANSWER_SHEET', val);
  },
  setVisibleDialog({ commit }, val) {
    commit('SET_VISIBLE_DIALOG', val);
  },
  setVisibleDialogIndex({ commit }, val) {
    commit('SET_VISIBLE_DIALOG_INDEX', val);
  },
  toogleScore({ commit }, val) {
    commit('SET_SCORE_VISIBLE', val);
  },
};

const getters = {
  answerSheet: state => state.answerSheet,
  acCardSetType: state => state.acCardSetType,
  visibleDialog: state => state.visibleDialog,
  visibleDialogIndex: state => state.visibleDialogIndex,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
